<template>
  <div class="referral">

    <!-- App Header -->
    <AppHeader
      justify-space-between
      border-bottom
    />

    <StepHeader
      title="Referral Application"
    />

    <StepContent
      width="lg"
    >
      <p>
        Someone you know has recently purchased a vehicle from Canada Drives and wants you to experience the same great service they did!
      </p>
      <p>
        Just complete this quick car loan application to get started. It’s free to apply and takes just minutes to complete.
      </p>

      <div class="input__container">
        <AppInput
          v-for="(field, index) in fields"
          :key="index"
          :placeholder="field.placeholder"
          :label="field.label"
          :error="field.error"
          :value="field.value"
          @input="handleInput(field.name, $event)"
        />
      </div>

      <AppButtonContinue @click="handleContinue()">
        Continue
      </AppButtonContinue>

    </StepContent>

    <AppFooter/>

  </div>
</template>

<script>

import AppButtonContinue from '@/components/common/buttons/AppButtonContinue'
import AppFooter from '@/components/common/layout/AppFooter'
import AppHeader from '@/components/common/layout/AppHeader'
import AppInput from '@/components/common/inputs/AppInput'
import StepContent from '@/components/common/step/StepContent'
import StepHeader from '@/components/common/step/StepHeader'

export default {
  name: 'referral',

  components: {
    AppButtonContinue,
    AppFooter,
    AppHeader,
    AppInput,
    StepContent,
    StepHeader
  },

  data () {
    return {
      firstName: '',
      lastName: '',
      submitted: false,
      errors: {
        isRequired: 'This field is required.',
        minCharacters: 'Please enter at least 2 characters.'
      }
    }
  },

  computed: {
    fields () {
      return [{
        label: 'I was referred by:',
        placeholder: 'Referrer First Name',
        name: 'firstName',
        value: this.firstName,
        error: this.firstNameError
      }, {
        label: ' ',
        placeholder: 'Referrer Last Name',
        name: 'lastName',
        value: this.lastName,
        error: this.lastNameError
      }]
    },
    firstNameError () {
      if (!this.submitted) return
      if (!this.firstName) return this.errors.isRequired
      if (this.firstName.trim().length < 2) return this.errors.minCharacters
    },
    lastNameError () {
      if (!this.submitted) return
      if (!this.lastName) return this.errors.isRequired
      if (this.lastName.trim().length < 2) return this.errors.minCharacters
    },
    fieldsAreValid () {
      if (!this.submitted) return
      if (this.firstNameError || this.lastNameError) return
      return true
    }
  },

  methods: {
    handleInput (field, value) {
      this[field] = value
    },
    handleContinue () {
      this.submitted = true
      if (this.fieldsAreValid) {
        this.$router.replace({
          path: '/',
          query: {
            ...this.$route.query,
            referrer_first_name: this.firstName,
            referrer_last_name: this.lastName
          }
        })
      }
    }
  }

}

</script>

<style scoped lang="scss">

  .step-header {
    padding: 20px;

    @include breakpoint('tablet-portrait-up') {
      padding: 40px;
    }
  }

  .app-button-continue {
    margin-top: 20px;

    @include breakpoint('tablet-portrait-up') {
      margin-top: 60px;
    }
  }

  .input__container {
    margin-top: 40px;
  }

  .step-content {

    flex-direction: column;
    margin-bottom: 100px;

    > p {
      text-align: center;
      font-size: 12px;
      line-height: 1.5;

      @include breakpoint('tablet-portrait-up') {
        font-size: 16px;
      }
    }
  }

  @include breakpoint('tablet-landscape-up') {
    .step-content {
      .input__container {
        display: flex;
        width: 100%;
        align-items: flex-end;
      }
    }
  }

</style>
